export default {"src":"/_next/static/media/apartment.f7db7aae.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};